import React, { useState } from 'react';
import { useAuthFetch } from '../hooks/useAuthFetch';

function AddGoal({ topic, topicName, existingStartDate, setGoalDate, setStartDate }) {
  const { authFetch } = useAuthFetch();
  const [startVal, setStartVal] = useState(existingStartDate || new Date().toISOString().split('T')[0]);
  const [goalVal, setGoalVal] = useState(
    new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
  );
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const res = await authFetch(`${process.env.REACT_APP_API_URL}/api/addGoal`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ start_date: startVal, goal_date: goalVal, topic }),
      });
      if (!res.ok) throw new Error(`Server returned ${res.status}`);
      setGoalDate(goalVal);
      if (setStartDate) setStartDate(startVal);
    } catch (err) {
      console.error('Error saving goal:', err);
      setError('Failed to save goal. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="study-add-goal">
      <p className="study-add-goal-title">Set exam goal date</p>
      <form onSubmit={handleSubmit} className="study-date-row">
        <div>
          <label className="study-date-label" htmlFor="start_date">Start date</label>
          <input
            className="study-date-input"
            type="date"
            id="start_date"
            value={startVal}
            onChange={e => setStartVal(e.target.value)}
            data-form-type="other"
          />
        </div>
        <div>
          <label className="study-date-label" htmlFor="goal_date">Exam date</label>
          <input
            className="study-date-input"
            type="date"
            id="goal_date"
            value={goalVal}
            onChange={e => setGoalVal(e.target.value)}
            data-form-type="other"
          />
        </div>
        <button type="submit" className="study-btn-goal-submit" disabled={submitting}>
          {submitting ? 'Saving…' : 'Set goal'}
        </button>
      </form>
      {error && <p className="study-goal-error">{error}</p>}
    </div>
  );
}

export default AddGoal;
